<template>
  <ToastClose as-child>
    <button type="button" :class="['btn-close d-flex', props.class]" aria-label="Close">
      <i class="bx bx-x" />
    </button>
  </ToastClose>
</template>

<script setup>
import { ToastClose } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: String, required: false },
})
</script>

<style scoped>
.btn-close {
  --gu-btn-close-color: inherit;
  --gu-btn-close-bg: none;
}
</style>
